import { Apple, Eye, RotateCw } from "lucide-react";
import React, { useEffect, useState } from "react";
import MyCard from "../../tools/MyCard";
import CheckButton from "../../global/CheckButton";
import { SolidButton } from "../../global/SolidButton";
import { PaperPlaneTilt } from "phosphor-react";
import MyLoader from "../../util/MyLoader";
import {
  getApps,
  getNotification,
  sendIntantNotification,
  sendScheduleNotification,
} from "../apps_manage/api";
import toast from "react-hot-toast";

export default function Notification() {
  const [app, selectApp] = useState("");
  const [filterApp, selectFilterApp] = useState(null);
  const [errors, setErrors] = useState(false);
  const [target, setTarget] = useState("all_user");
  const [title, setTitle] = useState("");
  const [datetime, setDatetime] = useState("");
  const [message, setMessage] = useState("");
  const [isSchedule, setIsSchedule] = useState(false);
  const [targetUser, setTargetUser] = useState("");
  const [channel, setChannel] = useState("old_users");
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [appList, setAppList] = useState([]);
  const [currentAppId, setCurrentAppId] = useState(null);
  const [appName, setAppName] = useState(null);

  const validateForm = () => {
    const errs = {};

    //app validation
    if (app === "") {
      errs.app = "select an app ";
    }
    //target user validation
    if (target === "target" && !targetUser.trim()) {
      errs.targetUser = "Target User is required for Targeted Notification";
    }

    //target channel validation
    if (target === "channel" && !channel.trim()) {
      errs.channel = "Channel is required for Group Notification";
    }

    //title  validation
    if (!title.trim()) {
      errs.title = "title  is required";
    }

    //message  validation
    if (!message.trim()) {
      errs.message = "message  is required";
    }

    //schedule validation
    if (isSchedule && !datetime) {
      errs.datetime = "Schedule Date & Time is required";
    }

    setErrors(errs);
    console.log("click to submit:" + errors.bucket);

    return Object.keys(errs).length === 0;
  };

  const fetchAppList = async () => {
    try {
      const res = await getApps();
      if (res?.status === 200) {
        const apps = res?.data?.apps || [];
        setAppList(apps);

        // restore selected app
        const savedApp = localStorage.getItem("selected_app");
        if (savedApp && apps.some((a) => String(a.id) === savedApp)) {
          selectApp(savedApp);
          selectFilterApp(savedApp);
          setCurrentAppId(savedApp);

          const selected = apps.find((a) => String(a.id) === String(savedApp));

          setAppName(selected?.name || "");
        } else if (apps.length > 0) {
          const firstApp = String(apps[0].id);

          selectApp(firstApp);
          selectFilterApp(firstApp);
          setCurrentAppId(firstApp);
          setAppName(apps[0].name);

          localStorage.setItem("selected_app", firstApp);
        }
      }
    } catch (err) {
      console.error("failed to fetch date :" + err);
    }
  };

  const fetchNotifications = async () => {
    console.log("app id :", currentAppId);
    try {
      const res = await getNotification(currentAppId);
      if (res?.status === 200) {
        const data = res?.data;

        setNotifications(data.data || []);
      }
    } catch (err) {
      console.error("failed to fetch date :" + err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAppList();
  }, []);

  useEffect(() => {
    if (!currentAppId) return;
    fetchNotifications();
  }, [currentAppId]);

  /* Restore last selected app */
  useEffect(() => {
    const savedApp = localStorage.getItem("selected_app");

    if (savedApp) {
      selectApp(savedApp);
    }
  }, []);

  /* Save whenever app changes */
  useEffect(() => {
    if (app) {
      localStorage.setItem("selected_app", app);
    }
  }, [app]);

  const formatISTDate = (value) => {
    if (!value) return "";

    // input: 2026-05-23T21:45
    // output: 2026-05-23 21:45:00

    return value.replace("T", " ");
  };
  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
      const payload = {
        app_id: Number(app),
        title: title,
        body: message,
        send_at: isSchedule ? formatISTDate(datetime) : "",
      };
      const res = isSchedule
        ? await sendScheduleNotification(payload)
        : await sendIntantNotification(payload);

      if (res.status == 200) {
        toast.success(res?.data?.message);
      }
    } catch (err) {
      console.error("failed to push notification data :", err);
    }

    //submit form
  };

  if (loading) return <MyLoader />;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-y-4 lg:gap-x-4 w-full  items-start  ">
      <MyCard className="w-full overflow-x-auto col-span-2 ">
        <table className="min-w-full border-collapse text-xs ">
          {/* HEADER */}
          <thead className="bg-slate-100 dark:bg-slate-800/60 border-y border-slate-300 dark:border-slate-700 text-slate-700 font-medium  dark:text-slate-300">
            <tr>
              {/* SEARCH + FILTER */}
              <th className="text-left px-4 py-3">
                <div className="flex flex-wrap items-center gap-2">
                  <input
                    type="text"
                    placeholder="Search by title or subtitle"
                    className="w-[200px] py-2 px-3 bg-slate-200/40 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />

                  <select
                    name="filterApp"
                    value={filterApp}
                    onChange={(e) => {
                      const selectedOption =
                        e.target.options[e.target.selectedIndex];
                      selectFilterApp(e.target.value);
                      setCurrentAppId(e.target.value);
                      setAppName(selectedOption.text);
                    }}
                    className="px-2 py-2 bg-slate-100 dark:bg-slate-800 rounded-md text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 focus:ring-2 focus:ring-blue-500"
                  >
                    {appList.map((app, index) => (
                      <option key={index} value={app.id}>
                        {app.name}
                      </option>
                    ))}
                  </select>
                </div>
              </th>

              <th className="text-left px-4 py-3">App</th>

              <th className="text-left px-4 py-3">
                <div className="flex flex-col leading-tight">
                  <span>Schedule</span>
                  <span className="text-[10px] opacity-70">Time</span>
                </div>
              </th>

              <th className="text-center px-4 py-3">Status</th>

              <th className="text-right px-4 py-3">
                <button
                  onClick={() => fetchNotifications()}
                  className="flex items-center gap-1 border px-2 py-1 rounded-md hover:bg-slate-200 dark:hover:bg-slate-700 transition"
                >
                  <RotateCw className="w-4 h-4" />
                  <span>Refresh</span>
                </button>
              </th>
            </tr>
          </thead>

          {/* BODY */}
          <tbody>
            {notifications.map((item, index) => (
              <tr
                key={index}
                className="border-b border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800/40 transition"
              >
                {/* TITLE */}
                <td className="px-4 py-3">
                  <div className="flex flex-col">
                    <span className="font-medium text-slate-900 dark:text-white">
                      {item.headings.en}
                    </span>
                    <span className="text-[11px] text-gray-500 dark:text-slate-400">
                      {item.contents.en}
                    </span>
                  </div>
                </td>

                {/* APP */}
                <td className="px-4 py-3 text-slate-900 dark:text-white">
                  {appName}
                </td>

                {/* DATE */}
                <td className="px-4 py-3">
                  <div className="flex flex-col">
                    <span className="font-medium dark:text-slate-200 text-slate-800">
                      {new Date(item.queued_at * 1000).toLocaleDateString(
                        "en-IN",
                        {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        },
                      )}
                    </span>
                    <span className="text-[11px] text-gray-500 dark:text-slate-400">
                      {new Date(item.queued_at * 1000).toLocaleTimeString(
                        "en-IN",
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: true,
                        },
                      )}
                    </span>
                  </div>
                </td>

                {/* STATUS */}
                <td className="px-4 py-3 text-center">
                  <span
                    className={`text-xs font-medium px-2 py-1 rounded-lg border ${
                      item.received
                        ? "text-green-500 bg-green-500/10 border-green-500"
                        : "text-yellow-500 bg-yellow-500/10 border-yellow-500"
                    }`}
                  >
                    {item.received ? "Sent" : "Queue"}
                  </span>
                </td>

                {/* ACTION */}
                <td className="px-4 py-3 text-right">
                  <Eye className="w-5 h-5 text-slate-700 dark:text-slate-300 cursor-pointer hover:scale-110 transition" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </MyCard>
      <MyCard className="w-full md:col-span-1  p-4 flex flex-col space-y-0">
        {/* header */}
        <div className="flex items-center justify-center ">
          <div className="flex flex-col">
            <h1 className="text-md text-slate-900 dark:text-slate-50 font-medium">
              Send Notification
            </h1>
            <span className="text-xs text-gray-500 dark:text-slate-400 ">
              Send real-time push notification via FCM
            </span>
          </div>

          <button className="flex items-center space-x-2 border-slate-700 dark:bg-slate-400/20 px-2 py-1 dark:border-slate-400 text-slate-900 dark:text-slate-50 border rounded-md ms-auto hover:bg-slate-400/30 transition-all">
            <RotateCw className=" w-4 h-4 " />
            <span className="text-xs ">Reset</span>
          </button>
        </div>
        <div className="grid grid-cols-2 gap-4 space-y-2 mt-4">
          {/* Select App */}
          <div className="">
            <label
              htmlFor="apiType"
              className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800"
            >
              Select App
            </label>

            <div className="relative mt-1 ">
              <select
                id="app"
                name="app"
                value={app}
                onChange={(e) => {
                  selectApp(e.target.value);
                  // // const selectedId = e.target.value;
                  // const selectedApp = appList.find(
                  //   (a) => a.id.toString() === e.target.value,
                  // );

                  // // find full object from list
                  // // const selectedApp = appList.find((a) => a.id === selectedId);

                  // selectApp(selectedApp); // store full object if needed
                  if (errors.app)
                    setErrors((prev) => ({ ...prev, app: undefined }));
                }}
                className={`w-full px-2 py-2 bg-slate-100 dark:bg-slate-800 rounded-md
        text-slate-900 dark:text-white text-xs placeholder-slate-500
        focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
      
        ${errors.app ? "border-red-500" : "border-slate-200 dark:border-slate-700"}
        
        `}
              >
                {appList.map((item, index) => (
                  <option key={index + app.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            {errors.app && (
              <p className="text-red-500 text-xs mt-1">{errors.app}</p>
            )}
          </div>
          {/* Target */}
          <div className="">
            <label
              htmlFor="apiType"
              className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800"
            >
              Target
            </label>

            <div className="relative mt-1">
              <select
                id="target"
                name="target"
                value={target}
                onChange={(e) => setTarget(e.target.value)}
                className="w-full px-2 py-2 bg-slate-100 dark:bg-slate-800 rounded-md
        text-slate-900 dark:text-white text-xs placeholder-slate-500
        focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
        
        border border-slate-200 dark:border-slate-700"
              >
                <option value="all_user">All Users</option>
                <option value="target">Target User</option>
                <option value="channel">Channel</option>
              </select>
            </div>
          </div>
        </div>

        {/* channels */}
        {target == "channel" && (
          <>
            <div className="">
              <label
                htmlFor="apiType"
                className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800"
              >
                Channel
              </label>

              <div className="relative mt-1">
                <select
                  id="channel"
                  name="channel"
                  value={channel}
                  onChange={(e) => setChannel(e.target.value)}
                  className="w-full px-2 py-2 bg-slate-100 dark:bg-slate-800 rounded-md
        text-slate-900 dark:text-white text-xs placeholder-slate-500
        focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
        
        border border-slate-200 dark:border-slate-700"
                >
                  <option value="old_users">Old Users</option>
                  <option value="latest_users">Latest User</option>
                  <option value="first_withdrawal">First Withdrawal</option>
                </select>
              </div>
            </div>
          </>
        )}

        {/* Target User */}
        {target === "target" && (
          <div className="mt-3">
            <label
              htmlFor="title"
              className="text-sm font-sans  dark:text-slate-200 text-slate-800"
            >
              Target User
            </label>
            <div className="relative">
              <input
                type="text"
                name="target_user"
                value={targetUser}
                onChange={(e) => {
                  setTargetUser(e.target.value);
                  if (errors.targetUser)
                    setErrors((prev) => ({ ...prev, targetUser: undefined }));
                }}
                placeholder="Enter User ID or FCM Token"
                className={`w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-1 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700`}
              />
              {errors.targetUser && (
                <p className="text-red-500 text-xs mt-1">{errors.targetUser}</p>
              )}
            </div>
          </div>
        )}
        {/* Title */}
        <div className="mt-3">
          <label
            htmlFor="title"
            className="text-sm font-sans  dark:text-slate-200 text-slate-800"
          >
            Title
          </label>
          <div className="relative">
            <input
              type="text"
              name="title"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                if (errors.title)
                  setErrors((prev) => ({ ...prev, title: undefined }));
              }}
              placeholder="Notification Title"
              className={`w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-1 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700`}
            />
            {errors.title && (
              <p className="text-red-500 text-xs mt-1">{errors.title}</p>
            )}
          </div>
        </div>
        {/* Message */}
        <div className="mt-3">
          <label
            htmlFor="title"
            className="text-sm font-sans  dark:text-slate-200 text-slate-800"
          >
            Message
          </label>
          <div className="relative">
            {/* max 2 line */}

            <textarea
              type="text"
              name="message"
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
                if (errors.message)
                  setErrors((prev) => ({ ...prev, message: undefined }));
              }}
              placeholder="Eg. Win more coins"
              className={`w-full h-20 px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 

                mt-1 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700`}
            />
            {errors.message && (
              <p className="text-red-500 text-xs mt-1">{errors.message}</p>
            )}
          </div>
        </div>
        {/* Schedule */}
        <div className="mt-3 flex items-center space-x-2">
          <CheckButton
            checked={isSchedule}
            onClick={() => {
              setIsSchedule(!isSchedule);
            }}
            size={22}
            className=""
          />
          <span className="text-sm text-slate-800 dark:text-slate-200">
            Schedule Notification
          </span>
        </div>
        {isSchedule && (
          <div className="mt-3">
            <label
              htmlFor="title"
              className="text-sm font-sans  dark:text-slate-200 text-slate-800"
            >
              Schedule Date & Time (IST)
            </label>
            <div className="relative">
              <input
                type="datetime-local"
                name="datetime"
                value={datetime}
                min={getMinDateTimeIST()}
                onChange={(e) => {
                  const selected = new Date(e.target.value);
                  const now = new Date();

                  if (selected < now) {
                    alert("Please select a future date & time");

                    // setDatetime('');

                    return;
                  }
                  setDatetime(e.target.value);
                  if (errors.datetime)
                    setErrors((prev) => ({ ...prev, datetime: undefined }));
                }}
                onFocus={(e) => e.target.showPicker && e.target.showPicker()}
                placeholder="Select Date & Time"
                className={`w-full ps-10 pe-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-1 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border 
                ${errors.datetime ? "border-red-500" : "border-slate-200 dark:border-slate-700"}
              
                `}
              />
              {errors.datetime && (
                <p className="text-red-500 text-xs mt-1">{errors.datetime}</p>
              )}
            </div>
          </div>
        )}

        <SolidButton
          onClick={(e) => handleSubmit(e)}
          className="w-full mt-4 flex items-center justify-center space-x-2"
        >
          <PaperPlaneTilt size={18} weight="bold" />
          <span className="">
            {isSchedule ? "Schedule Notification" : "Send Now"}
          </span>
        </SolidButton>
      </MyCard>
    </div>
  );
}

// const getMinDateTime = () => {
//   const now = new Date();
//   now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
//   return now.toISOString().slice(0, 16);
// };

const getMinDateTimeIST = () => {
  const now = new Date();

  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(now);

  const get = (type) => parts.find((p) => p.type === type)?.value;

  return `${get("year")}-${get("month")}-${get("day")} ${get("hour")}:${get("minute")}:${get("second")}`;
};

console.log(getMinDateTimeIST());
